export const THERAPIST_NAV_TRANSLATIONS = {
  home: { "pt-BR": "Início", en: "Home", es: "Inicio" , de: "Heim"},
  agenda: { "pt-BR": "Agenda", en: "Schedule", es: "Agenda" , de: "Zeitplan"},
  patients: { "pt-BR": "Pacientes", en: "Patients", es: "Pacientes" , de: "Patientinnen"},
  finance: { "pt-BR": "Financeiro", en: "Finance", es: "Finanzas" , de: "Finanzen"},
  secretaryTeam: { "pt-BR": "Time administrativo", en: "Administrative team", es: "Equipo administrativo" , de: "Verwaltungsteam"},
  requests: { "pt-BR": "Solicitações", en: "Requests", es: "Solicitudes" , de: "Anfragen"},
  patientChat: { "pt-BR": "Chat com pacientes", en: "Patient chat", es: "Chat con pacientes" , de: "Patientenchat"},
  teamChat: { "pt-BR": "Chat com equipe", en: "Team chat", es: "Chat con el equipo" , de: "Team-Chat"},
  settings: { "pt-BR": "Configurações", en: "Settings", es: "Configuración" , de: "Einstellungen"},
  privacy: { "pt-BR": "Privacidade", en: "Privacy", es: "Privacidad" , de: "Privatsphäre"},
  marketplace: { "pt-BR": "Marketplace", en: "Marketplace", es: "Marketplace" , de: "Marktplatz"},
  subscription: { "pt-BR": "Assinatura", en: "Subscription", es: "Suscripción" , de: "Abonnement"},
  profile: { "pt-BR": "Perfil", en: "Profile", es: "Perfil" , de: "Profil"},
  clinicManagement: { "pt-BR": "Gestão Clínica", en: "Clinic management", es: "Gestión clínica" , de: "Klinikleitung"},
  chatShort: { "pt-BR": "Chat", en: "Chat", es: "Chat" , de: "Chatten"},
} as const;

export const SECRETARY_NAV_TRANSLATIONS = {
  home: { "pt-BR": "Início", en: "Home", es: "Inicio" , de: "Heim"},
  agenda: { "pt-BR": "Agenda", en: "Schedule", es: "Agenda" , de: "Zeitplan"},
  patients: { "pt-BR": "Pacientes", en: "Patients", es: "Pacientes" , de: "Patientinnen"},
  finance: { "pt-BR": "Financeiro", en: "Finance", es: "Finanzas" , de: "Finanzen"},
  requests: { "pt-BR": "Solicitações", en: "Requests", es: "Solicitudes" , de: "Anfragen"},
  patientChat: { "pt-BR": "Chat com pacientes", en: "Patient chat", es: "Chat con pacientes" , de: "Patientenchat"},
  teamChat: { "pt-BR": "Chat com equipe", en: "Team chat", es: "Chat con el equipo" , de: "Team-Chat"},
  professionalChat: { "pt-BR": "Chat com profissional", en: "Professional chat", es: "Chat con el profesional" , de: "Professioneller Chat"},
  settings: { "pt-BR": "Configurações", en: "Settings", es: "Configuración" , de: "Einstellungen"},
  profile: { "pt-BR": "Perfil", en: "Profile", es: "Perfil" , de: "Profil"},
} as const;

export const PARENT_NAV_TRANSLATIONS = {
  home: { "pt-BR": "Início", en: "Home", es: "Inicio" , de: "Heim"},
  agenda: { "pt-BR": "Agenda", en: "Schedule", es: "Agenda" , de: "Zeitplan"},
  family: { "pt-BR": "Família", en: "Family", es: "Familia" , de: "Familie"},
  evolution: { "pt-BR": "Evolução", en: "Progress", es: "Evolución" , de: "Fortschritt"},
  goals: { "pt-BR": "Objetivos", en: "Goals", es: "Objetivos" , de: "Ziele"},
  guidance: { "pt-BR": "Orientações", en: "Guidance", es: "Orientaciones" , de: "Anleitung"},
  media: { "pt-BR": "Fotos e vídeos", en: "Photos and videos", es: "Fotos y videos" , de: "Fotos und Videos"},
  notes: { "pt-BR": "Observações", en: "Notes", es: "Observaciones" , de: "Notizen"},
  meetingMinutes: { "pt-BR": "Atas de reunião", en: "Meeting minutes", es: "Actas de reunión", de: "Sitzungsprotokolle" },
  requests: { "pt-BR": "Solicitações", en: "Requests", es: "Solicitudes" , de: "Anfragen"},
  chat: { "pt-BR": "Chat", en: "Chat", es: "Chat" , de: "Chatten"},
  finance: { "pt-BR": "Financeiro", en: "Finance", es: "Finanzas" , de: "Finanzen"},
  settings: { "pt-BR": "Configurações", en: "Settings", es: "Configuración" , de: "Einstellungen"},
  profile: { "pt-BR": "Perfil", en: "Profile", es: "Perfil" , de: "Profil"},
} as const;

export const CLINIC_MANAGER_NAV_TRANSLATIONS = {
  clinicData: {
    "pt-BR": "Dados da clínica",
    en: "Clinic details",
    es: "Datos de la clínica",
    de: "Klinikdaten",
  },
  units: { "pt-BR": "Unidades", en: "Units", es: "Unidades", de: "Einheiten" },
  team: { "pt-BR": "Equipe", en: "Team", es: "Equipo" , de: "Ausrüstung"},
  teamChat: { "pt-BR": "Chat com equipe", en: "Team chat", es: "Chat con el equipo" , de: "Team-Chat"},
  settings: { "pt-BR": "Configurações", en: "Settings", es: "Configuración" , de: "Einstellungen"},
  marketplace: { "pt-BR": "Marketplace", en: "Marketplace", es: "Marketplace" , de: "Marktplatz"},
  subscription: { "pt-BR": "Assinatura", en: "Subscription", es: "Suscripción" , de: "Abonnement"},
  professionalOffice: { "pt-BR": "Consultório profissional", en: "Professional office", es: "Consultorio profesional" , de: "Professionelles Büro"},
} as const;

export const NAV_AREA_LABEL_TRANSLATIONS = {
  admin: { "pt-BR": "Administração", en: "Administration", es: "Administración" , de: "Verwaltung"},
  secretary: { "pt-BR": "Secretária", en: "Secretary", es: "Secretaria" , de: "Sekretärin"},
  finance: { "pt-BR": "Financeiro", en: "Finance", es: "Finanzas" , de: "Finanzen"},
  clinic: { "pt-BR": "CLÍNICA", en: "CLINIC", es: "CLÍNICA" , de: "KLINIK"},
  professional: { "pt-BR": "Profissional", en: "Professional", es: "Profesional" , de: "Fachkraft"},
  parent: { "pt-BR": "Paciente / Responsável", en: "Patient / Guardian", es: "Paciente / Responsable" , de: "Patient/Erziehungsberechtigter"},
} as const;

export const APP_LAYOUT_TRANSLATIONS = {
  unreadMessages: { "pt-BR": "não lidas", en: "unread", es: "sin leer" , de: "ungelesen"},
  collapseMenu: { "pt-BR": "Recolher menu", en: "Collapse menu", es: "Contraer menú" , de: "Menü einklappen"},
  expandMenu: { "pt-BR": "Expandir menu", en: "Expand menu", es: "Expandir menú" , de: "Menü erweitern"},
  logout: { "pt-BR": "Sair", en: "Sign out", es: "Salir" , de: "Abmelden"},
  moreOptions: { "pt-BR": "Mais opções", en: "More options", es: "Más opciones" , de: "Weitere Optionen"},
  menu: { "pt-BR": "Menu", en: "Menu", es: "Menú" , de: "Speisekarte"},
  moreNavOptions: { "pt-BR": "Mais opções de navegação", en: "More navigation options", es: "Más opciones de navegación" , de: "Weitere Navigationsmöglichkeiten"},
  parentBannerTitle: { "pt-BR": "Modo inicial:", en: "Getting started:", es: "Modo inicial:" , de: "Erste Schritte:"},
  parentBannerBody: {
    "pt-BR": "cadastre um paciente em",
    en: "register a patient in",
    es: "registre un paciente en",
    de: "einen Patienten registrieren",
  },
  parentBannerProfileLink: { "pt-BR": "Perfil", en: "Profile", es: "Perfil" , de: "Profil"},
  parentBannerSuffix: {
    "pt-BR": "e vincule pelo menos um profissional pelo código de convite. Sem esse vínculo ativo, agenda, chat e demais áreas ficam limitadas.",
    en: "and link at least one professional using the invite code. Without an active link, schedule, chat, and other areas stay limited.",
    es: "y vincule al menos un profesional con el código de invitación. Sin ese vínculo activo, agenda, chat y otras áreas quedan limitadas.",
    de: "und verlinken Sie mindestens einen Fachmann mithilfe des Einladungscodes. Ohne einen aktiven Link bleiben Zeitplan, Chat und andere Bereiche eingeschränkt.",
  },
} as const;
